import styled from "styled-components";

const PageContainer = styled.div`
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export default PageContainer;
